// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3uXxI","colMin":"styles_colMin__T9LkD","colCheckbox":"styles_colCheckbox__1P7cm"};